enum Paths {
  EnterprisePage = '/enterprises',
  CreateEnterprise = '/enterprise/new',
  EditEnterprise = '/enterprise/edit/:id',
  UsersPage = '/users',
  CreateUser = '/users/new',
  EditUser = '/users/edit/:id',
  LoginPage = '/login',
  CvVideos = '/cv-videos',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password',
  CvVideoDetails = '/cv-videos/:id',
  EstablishmentPage = '/establishments',
  CreateEstablishment = '/establishments/new',
  EditEstablishment = '/establishments/edit/:id',
  JobsPage = '/jobs',
  JobsDetails = '/jobs/:id',
  CandidatePage = '/candidates',
  CandidateDetails = '/candidates/:id',
  NotificationsPage = '/',
  SettingsPage = '/settings-page',
  CreditsPage = '/credits-page',
  CreateTopUps = '/credits-page/createTopUps',
  DetailsTopUps = '/credits-page/details-top-up/:id',
}

export default Paths;
